import {isError} from 'lodash'
const Sentry = typeof window !== 'undefined' && window.Sentry

/* eslint-disable */
function init(callback) {
  const d = parseInt(new Date().getTime()) / 1000 / 60 / 30
  const l = document.createElement('script')

  l.type = 'text/javascript'
  l.async = true
  l.src = '//cdn.logz.io/logger.min.js?d=' + d
  l.addEventListener('load', () => callback && callback())
  document.getElementsByTagName('head')[0].appendChild(l)
}
/* eslint-enable */

let logzioLogger

const getLogzioLogger = logzioId => new Promise(resolve => {
  if (logzioLogger) {
    resolve(logzioLogger)
  } else {
    init(() => {
      logzioLogger = new window.LogzioLogger(logzioId)
      resolve(logzioLogger)
    })
  }
})

export default function remoteLogWithLevel(level, args, config){
  logWithLogzio(level, args, config)
  logWithSentry(level, args, config)
}

function logWithLogzio(level, [errorOrMessage, ...otherArgs], config){
  getLogzioLogger(config.logzioId)
    .then(logzioLogger => {
      // eslint-disable-next-line no-unused-vars
      const {logzioId, ...cleanConfig} = config
      logzioLogger.log({
        level,
        message: isError(errorOrMessage) ? errorOrMessage.message : errorOrMessage,
        args: JSON.stringify(otherArgs).substring(0, 1500),
        sessionId: 'n.a',
        visitorId: 'n.a',
        ...cleanConfig
      })
    })
}

const badLoggingErrorMessage = new Error('Bad error logging arguments. Logger.error must receive and error as it`s first argument.')

function logWithSentry(level, [errorOrMessage, ...otherArgs], config){
  if(!Sentry){
    console.error('No Sentry Found.')
    return
  }

  const logger = config.appName
  // eslint-disable-next-line no-unused-vars
  const {logzioId, ...cleanConfig} = config

  const extra = {
    args: otherArgs,
    sessionId: 'n.a',
    visitorId: 'n.a',
    ...cleanConfig
  }

  if (level !== 'error') {
    Sentry.addBreadcrumb({
      message: errorOrMessage,
      data: extra,
      category: logger,
      level
    })
    return
  }

  if (isError(errorOrMessage)) {
    Sentry.withScope(scope => {
      scope.setExtra('extra', extra)
      scope.setExtra('logger', logger)
      Sentry.captureException(errorOrMessage)
    })
    return
  }

  Sentry.withScope(scope => {
    scope.setExtra('extra', {
      ...extra,
      args: [errorOrMessage, ...otherArgs]
    })
    scope.setExtra('logger', logger)
    Sentry.captureException(badLoggingErrorMessage)
  })
}
